import './index.scss';

import imgexport3 from '../../../../../assets/images/para-sua-empresa/produtos-protecao/img-protecao3@2x.png';

export const NDF = () => {

    return (
        <div className='container-select-credit'>
            <div className='cont-dados-1'>
                <h1> NDF (Non-Deliverable Forward) </h1>

                <p>
                    Um NDF (Non-Deliverable Forward) cambial é um contrato a termo de câmbio
                    em que não há entrega física das moedas envolvidas na transação.
                    Em vez disso, a diferença entre a taxa de câmbio acordada no contrato e a
                    taxa de câmbio spot no vencimento é liquidada em uma moeda de referência,
                    geralmente o dólar americano.
                </p>

                <p style={{ fontWeight: 'bold' }}>
                    Características principais:
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Sem entrega física: </span>A principal característica do NDF é a ausência de entrega
                    física das moedas. Isso o torna mais prático e menos custoso do que um
                    contrato a termo tradicional.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Liquidação em moeda de referência: </span>A liquidação é feita em uma moeda de
                    referência, geralmente o dólar americano.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Utilizado para moedas não conversíveis ou com restrições: </span>NDFs são
                    frequentemente utilizados para moedas de países com restrições cambiais ou
                    moedas não conversíveis, onde a entrega física seria difícil ou impossível.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Instrumento de hedge: </span>Os NDFs são utilizados principalmente para proteger
                    contra o risco cambial, permitindo que empresas e investidores se protejam das
                    flutuações das taxas de câmbio.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>Especulação: </span>Também podem ser utilizados para especular sobre a direção
                    futura das taxas de câmbio.
                </p>

            </div>
            <div className='cont-dados-2'>
                <img alt={imgexport3} src={imgexport3} />
                <div>
                    <h1> Vantagens </h1>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Flexibilidade: </span>Os NDFs oferecem flexibilidade em termos
                        de tamanho do contrato e data de vencimento.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Custo-benefício: </span>A ausência de entrega física reduz os
                        custos de transação.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Acesso a mercados com restrições: </span>Permitem acesso a
                        mercados cambiais que seriam inacessíveis com contratos tradicionais.
                    </p>

                    <div className='buttons-style inv' style={{marginTop:"10px"}}>
                        <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                    </div>
                </div>
            </div>
        </div>

    )
}

